import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import FormLabel from '@material-ui/core/FormLabel';
import Divider from '@material-ui/core/Divider';
import CombineSelector from '../../components/combineSelector';

import Selector from '../../components/selector';
import HintBlock from '../../components/hintBlock';
import ContractBlock from '../../components/contractBlock';

import VariableTextField from '../../components/variableTextField';

import { useAPI } from '../../utils/api';
import { useDialog } from '../../utils/dialog';
import UserAndServiceTerms from './_userAndServiceTerms';

const Section = styled.div`
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

const RegisterPage = () => {
  const api = useAPI();
  const dialog = useDialog();

  const [isUnmounted, setIsUnmounted] = useState(false);
  const [cityList, setCityList] = useState([]);
  const [isAgreementChecked, setIsAgreementChecked] = useState();

  const [industryTypes, setIndustryTypes] = useState([]);
  const [bankCodes, setBankCodes] = useState([]);

  const register = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    if (!isAgreementChecked) {
      dialog.openAlert({ message: '您尚未同意會員合約條款' });
      return;
    }

    const userToRegister = {
      companyName: data.get('companyName'), // 公司名稱
      email: data.get('email'), // 請款通知 Email
      mobile: data.get('mobile'), // 行動電話
      companyTelCity: data.get('companyTelCity'), // 區碼(公司電話)
      companyTel: data.get('companyTel'), // 公司電話
      companyTelExt: data.get('companyTelExt'), // 分機號碼(公司電話)
      city: data.get('city'), // 縣市(地址)
      industryType: data.get('industryType'), //產業類別
      district: data.get('district'), // 區域(地址)
      address: data.get('address'), // 地址
      personInCharge: data.get('personInCharge'), // 負責人
      paymentMethod: data.get('paymentMethod'), // 付款方式
      taxID: data.get('taxID'), // 統一編號
      bankCode: data.get('bankCode'), // 銀行代碼
      bankAccount: data.get('bankAccount'), // 銀行帳戶
      isAgreementChecked: isAgreementChecked, // 銀行帳戶
    };

    // console.log('userToRegister', JSON.stringify(userToRegister));

    api
      .register(userToRegister)
      .then(() => {
        dialog.openAlert({
          message: '註冊成功，啟用信已發送。請至您的信箱中做帳號啟用動作。',
          redirectTo: '/login',
        });
      })
      .catch(() => {});
  };

  useEffect(() => {
    api
      .getDropdownCitys()
      .then((citys) => {
        if (!isUnmounted) {
          setCityList(citys);
        }
      })
      .catch(() => {});

    api
      .getIndustryTypes()
      .then((result) => {
        if (!isUnmounted) {
          setIndustryTypes(result);
        }
      })
      .catch(() => {});

    api
      .getDropdownBankCodes()
      .then((banks) => {
        if (!isUnmounted) {
          setBankCodes(banks);
        }
      })
      .catch(() => {});

    return () => {
      setIsUnmounted(true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>

        <Typography component="h1" variant="h5">
          契約客戶註冊
        </Typography>

        <Box component="form" noValidate onSubmit={register} sx={{ mt: 3 }}>
          <Section>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div className="mt-2 font-bold text-center">基本資料</div>
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ marginBottom: '0.5rem' }} />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item xs={12}>
                <VariableTextField
                  locked
                  name="id"
                  label="會員編號"
                  text="系統自動帶入"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  id="companyName"
                  label="公司名稱"
                  name="companyName"
                  helperText="請輸入2-20個中英文數字"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label="請款通知 Email"
                  name="email"
                  autoComplete="email"
                  helperText="系統認證信將發送到信箱，請填寫正確資訊，避免遺漏相關信件"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="mobile"
                  label="行動電話"
                  name="mobile"
                  type="tel"
                />
              </Grid>

              <Grid item xs={12}>
                <FormLabel>公司電話</FormLabel>
              </Grid>

              <Grid item container columns={20} alignItems="center">
                <Grid item xs={3}>
                  <TextField
                    required
                    id="companyTelCity"
                    name="companyTelCity"
                    type="tel"
                    size="small"
                    autoComplete="none"
                  />
                </Grid>
                <Grid item xs={1}>
                  <div style={{ textAlign: 'center' }}>-</div>
                </Grid>
                <Grid item xs={9} sx={{ paddingLeft: 0 }}>
                  <TextField
                    required
                    id="companyTel"
                    name="companyTel"
                    type="tel"
                    size="small"
                    autoComplete="none"
                  />
                </Grid>
                <Grid item xs={1}>
                  <div style={{ textAlign: 'center' }}>#</div>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="companyTelExt"
                    name="companyTelExt"
                    type="tel"
                    size="small"
                    autoComplete="none"
                  />
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <FormLabel>地址</FormLabel>
              </Grid>

              <CombineSelector
                xs={6}
                sm={6}
                isVariable={false}
                optionsList={{
                  firstName: 'city',
                  firstLabel: '縣市',
                  options: cityList,
                  secondName: 'district',
                  secondLabel: '區域',
                }}
                secondOptionsKeyName="districts"
                variant="outlined"
              />

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  id="address"
                  label="請輸入地址"
                  name="address"
                  helperText="目前服務縣市只涵蓋雙北，後續會陸續增加服務範圍，敬請見諒！"
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  id="personInCharge"
                  label="負責人"
                  name="personInCharge"
                />
              </Grid>
              <Grid item xs={12}>
                <Selector
                  name="industryType"
                  label="產業類型"
                  placeHolder="產業類型"
                  options={industryTypes}
                  variant="outlined"
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
          </Section>

          <Section>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div className="mt-2 font-bold text-center">帳務資料</div>
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ marginBottom: '0.5rem' }} />
              </Grid>

              <Grid item xs={12}>
                <Selector
                  name="paymentMethod"
                  label="付款方式"
                  placeHolder="付款方式"
                  options={[{ value: '2', text: '預購' }]}
                  variant="outlined"
                  required
                  fullWidth
                  defaultValue="2"
                  readOnly
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  id="taxID"
                  label="統一編號"
                  name="taxID"
                />
              </Grid>

              <Grid item xs={12}>
                <Selector
                  name="bankCode"
                  label="銀行代碼"
                  placeHolder="銀行代碼"
                  options={bankCodes}
                  variant="outlined"
                  required
                  fullWidth
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  id="bankAccount"
                  label="銀行帳戶"
                  name="bankAccount"
                  helperText="請輸入正確的銀行帳戶，避免無法轉帳問題產生"
                />
              </Grid>
              <Grid item xs={12}>
                <HintBlock className="opacity-70 text-xs">
                  <h1>注意事項:</h1>
                  <div>1. 付款方式：系統自動帶預購。</div>
                  <div>
                    2.
                    請款日：當點數使用完畢，請匯款給即刻送，才可進行叫件服務。
                  </div>
                  <div>3. 結帳日：送完快遞簽收後，當日扣除點數。</div>
                  <div>
                    若需調整相關項目(修改請款模式，例
                    月結)，可註冊完成後，撥打即刻送客服專線： (02)2768-0285
                  </div>
                </HintBlock>
              </Grid>
            </Grid>
          </Section>

          <Section>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div className="mt-2 font-bold text-center">會員合約</div>
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ marginBottom: '0.5rem' }} />
              </Grid>

              <Grid item xs={12}>
                <ContractBlock>
                  <UserAndServiceTerms />
                </ContractBlock>
              </Grid>

              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      value="allowExtraEmails"
                      color="primary"
                      onChange={(event) => {
                        setIsAgreementChecked(event.target.checked);
                      }}
                    />
                  }
                  label={
                    <div>
                      我已詳細閱讀並同意以上會員合約和
                      <Link underline="none" href="/#/privacy-policy">
                        隱私權聲明
                      </Link>
                    </div>
                  }
                />
              </Grid>
            </Grid>
          </Section>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            確認送出
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default RegisterPage;
